import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../utils/url-utils/urlUtils';

export function getCommentaryUrl(
  url: string,
  accessPremium: boolean,
  source: string,
) {
  const internalUrl = isUrlInternal(url);
  let commentUrl = url;
  if (internalUrl && accessPremium) {
    commentUrl = buildUrlWithParameters(url, {
      source,
    });
  }
  return commentUrl;
}
